import React from "react"

import { RrsCategoryFilters } from "client/store"
import { SearchBar } from "client/components"

interface SearchRrsCategory {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    filters: RrsCategoryFilters
    onFilter: (filters: RrsCategoryFilters) => void
}

const RrsCategorySearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    filters,
    onFilter,
}: SearchRrsCategory) => (
    <SearchBar
        id={id}
        filters={filters}
        leftOffset={leftOffset}
        rightOffset={rightOffset}
        onFilter={onFilter}
    />
)
export default RrsCategorySearch
